import { BaseApi } from './base-api';
import { GUARD_ENDPOINTS } from '@/config/api';
import type { Guard, GuardList } from '@/types/guard';

export class GuardApi extends BaseApi {
  static async getPinCodes(): Promise<GuardList> {
    return this.getList<Guard>(GUARD_ENDPOINTS.PIN_CODES);
  }
}
